import LoadingActions from "@/store/actions/loading";

const state = {
    loading: false
};

const getters = {
    isLoading: state => state.loading
}

const actions = {
    [LoadingActions.LOADING]: ({commit, dispatch}, value) => {
        return new Promise((resolve, reject) => {
            commit(LoadingActions.LOADING, value)
            resolve()
        })
    }
};

const mutations = {
    [LoadingActions.LOADING]: (state, value) => {
        state.loading = value;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}